const loginUser = (request) => {
    return new Promise((res, rej) => {
        axios.post('merchant/login', request)
            .then((response) => {
                res(response.data);
            })
            .catch((err) => {
                rej(err);
            })
    })
};

const logout = (request) => {
    return new Promise((res, rej) => {
        axios.get('merchant/logout', request)
            .then((response) => {
                res(response.data);
            })
            .catch((err) => {
                rej(err);
            })
    })
};

const employeeLogout = (request) => {
    request = {
        terminal_unique_id: localStorage.getItem("unique_terminal_id")
    };
    return new Promise((res, rej) => {
        axios.post('merchant/employeelogout', request)
            .then((response) => {
                res(response.data);
            })
            .catch((err) => {
                rej(err);
            })
    })
};

export default {
    loginUser,
    logout,
    employeeLogout
};